'use client'

import { memo } from 'react'
import { ProductDownloadSection } from '@/app/ninxl/_components/product-download-section'
import { NINK_GITHUB_URL } from './nink-links'

export const NINK_DOWNLOAD_API = '/api/nink/download'

/**
 * baby: Primary downloads via Vercel Blob (/api/nink/download). GitHub is a soft source link only.
 */
export const NinkDownloadCta = memo(function NinkDownloadCta() {
  return (
    <div className="flex flex-col items-center gap-4">
      <ProductDownloadSection
        productLabel="NINK"
        productDescription="Voice writing for your desktop. On device by default."
        apiBase={NINK_DOWNLOAD_API}
        queryKey={['nink', 'download-hero']}
        recommended
        variant="primary"
        layout="inline"
      />

      <p className="nink-hybrid-body max-w-md text-center text-sm">
        Free to start · Mac + Windows.{' '}
        <a
          href={NINK_GITHUB_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="ninxl-theme-link font-semibold"
        >
          Source on GitHub
        </a>
        .
      </p>
    </div>
  )
})
